var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 8.00065C1.33325 4.33398 4.33325 1.33398 7.99992 1.33398C11.6666 1.33398 14.6666 4.33398 14.6666 8.00065C14.6666 11.6673 11.6666 14.6673 7.99992 14.6673C4.33325 14.6673 1.33325 11.6673 1.33325 8.00065ZM10.7999 5.20065C11.0666 5.46732 11.0666 5.86732 10.7999 6.13398L8.93325 8.00065L10.7999 9.86732C11.0666 10.134 11.0666 10.534 10.7999 10.8007C10.5333 11.0673 10.1333 11.0673 9.86659 10.8007L7.99992 8.93398L6.13325 10.8007C5.86659 11.0673 5.46659 11.0673 5.19992 10.8007C4.93325 10.534 4.93325 10.134 5.19992 9.86732L7.06659 8.00065L5.19992 6.13398C4.93325 5.86732 4.93325 5.46732 5.19992 5.20065C5.46659 4.93398 5.86659 4.93398 6.13325 5.20065L7.99992 7.06732L9.86659 5.20065C10.1333 4.93398 10.5333 4.93398 10.7999 5.20065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.85a128a7d505efcc8ed3d0c73cc07a59.svg";
export { ForwardRef as ReactComponent };